// extracted by mini-css-extract-plugin
module.exports = {"content":"_3tqZb","text":"_25lPb"};